import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconShareAltSvg } from "./IconShareAltSvg.mjs";
const IconShareAlt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconShareAltSvg, ...iconProps });
};
export {
  IconShareAlt
};
